var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_star_4409111_000000",
    transform: "translate(4.000000, 5.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8993391,1.37557065 C22.631476,0.556220012 21.863449,0 20.9999514,0 C20.1345358,0 19.3684316,0.556220012 19.1005638,1.37557065 L15.0619732,13.7575699 L1.99657981,13.7575699 C1.13116414,13.7575699 0.365060027,14.31379 0.0971921281,15.1331406 C-0.168800791,15.9524912 0.123416904,16.8521619 0.823974419,17.3598363 L11.3943505,25.0105492 L7.35576002,37.3925485 C7.08789692,38.2118991 7.38198432,39.1115698 8.08067213,39.6192442 C8.78122389,40.1269186 9.72907152,40.1269186 10.4296233,39.6192442 L21,31.9685314 L31.5703755,39.6192442 C32.2709273,40.1269186 33.2187749,40.1269186 33.9193267,39.6192442 C34.6180082,39.1115698 34.9121067,38.2138104 34.6442388,37.3925485 L30.6056483,25.0105492 L41.1760244,17.3598363 C41.8765761,16.8521619 42.1688044,15.9544025 41.9028066,15.1331406 C41.6349435,14.31379 40.8669165,13.7575699 40.003419,13.7575699 L26.9380255,13.7575699 L22.899435,1.37557065 L22.8993391,1.37557065 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.6575e2b2.svg";
export { ForwardRef as ReactComponent };